import store from "store";
import moneyQueue from "img/money-queue-success.svg";
import successImg from "img/success-img.svg";
import errorImg from "img/error-img.svg";
import questionImg from "img/question-img.svg";

const toast = {
  success: (message: string, buttonLabel?: string) =>
    store.dispatch({ type: "OPEN_TOAST", data: { text: message, icon: successImg, buttonLabel } }),
  successMoney: (message: string, buttonLabel?: string) =>
    store.dispatch({ type: "OPEN_TOAST", data: { text: message, icon: moneyQueue, buttonLabel } }),
  info: (title: string, message: string, icon?: string, buttonLabel?: string) =>
    store.dispatch({ type: "OPEN_TOAST", data: { title: title, text: message, icon: icon ?? questionImg, buttonLabel } }),
  error: (message: string, buttonLabel?: string) =>
    store.dispatch({ type: "OPEN_TOAST", data: { text: message, icon: errorImg, buttonLabel } }),
  errorCustom: (title: string, message: string | JSX.Element | JSX.Element[], icon?: string,
    important?: boolean, buttonLabel?: string, titleSize?: number,
    descriptionSize?: number, html?: boolean, actionButtonClose?: Function) =>
    store.dispatch({
      type: "OPEN_TOAST", data:
        { title, text: message, icon: icon || errorImg, buttonLabel, important, titleSize, descriptionSize, html, actionButtonClose }
    }),
  yesNo: (message: string, actionButton: any, buttonActionLabel?: string,
    buttonLabel?: string, iconHeight?: number, descriptionSize?: number,
    actionButtonClose?: Function) =>
    store.dispatch({
      type: "OPEN_TOAST", data:
        { text: message, icon: questionImg, actionButton, buttonActionLabel, buttonLabel, iconHeight, descriptionSize, actionButtonClose }
    }),
  yesNoProtocol: (title: string, message: string, actionButton: any, buttonActionLabel?: string, buttonLabel?: string) =>
    store.dispatch({
      type: "OPEN_TOAST", data:
        { title: title, text: message, icon: questionImg, actionButton, buttonActionLabel, buttonLabel }
    }),
  yesNoCustom: (
    title: string,
    message: string | JSX.Element | JSX.Element[] | Function,
    actionButton: any,
    icon?: string,
    iconHeight?: number,
    buttonActionLabel?: string | Function,
    buttonLabel?: string,
    trackItem?: string,
    trackAction?: string,
    widthContainer?: number,
    modalInitial?: boolean,
    isTextAlignLeft?: boolean,
    actionButtonClose?: Function,

  ) =>
    store.dispatch({
      type: "OPEN_TOAST", data:
      {
        title: title,
        text: message,
        icon: icon ?? questionImg,
        iconHeight: iconHeight,
        actionButton,
        buttonActionLabel,
        buttonLabel,
        trackItem,
        trackAction,
        widthContainer,
        modalInitial,
        isTextAlignLeft,
        actionButtonClose
      }
    }),
    withComponent: (title: string, component: JSX.Element, buttonLabel?: string, titleSize?: number) =>
      store.dispatch({
        type: "OPEN_TOAST", data:
          { title: title, component, buttonLabel, titleSize }
      }),
};

export default toast;